import { Box, Link, Typography } from '@mui/material';
import { translateBlock } from 'i18n';
import routes from 'modules/datacatalog/routes';
import type { TableSynopsis } from 'modules/datacatalog/types';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';
import Flex from 'ui/Flex/Flex';

type Props = {
    data: Extract<TableSynopsis, { hasSynopsis: true }>;
};

const TableDataPreview = ({ data }: Props) => {
    const { t } = useTranslation();

    const { general } = data.meta;

    return (
        <Flex direction="column" gap={1}>
            <Flex gap={1} alignItems="baseline">
                <Typography variant="subtitle2">
                    {t('dataCatalog.nbLines')}
                </Typography>
                <Typography variant="body2">
                    {general.nbLines.toLocaleString()}
                </Typography>
            </Flex>
            {general.defaultTime ? (
                <Flex gap={1} alignItems="baseline">
                    <Typography variant="subtitle2">
                        {t('dataCatalog.defaultTime')}
                    </Typography>
                    {general.defaultTimeIsHidden ? (
                        <Typography variant="body2">
                            {translateBlock(general.defaultTime)}
                        </Typography>
                    ) : (
                        <Link
                            component={RouterLink}
                            to={`${routes.dataCatalog}?field=${encodeURIComponent(general.defaultTime)}`}
                            variant="body2"
                        >
                            {translateBlock(general.defaultTime)}
                        </Link>
                    )}
                </Flex>
            ) : (
                <Box />
            )}
        </Flex>
    );
};

export default TableDataPreview;
